import React from "react";
import { formatQty } from "../../../../../utils/formatyQtd";
import { QuantityValueContainer } from "./styles";

interface IQuanityValue {
    inputValue: string;
    un?: string;
}

export function QuantityValue({
    inputValue,
    un,
}: IQuanityValue) {
    return (
        <QuantityValueContainer
            id="input-qtd-product"
        >
         {formatQty(inputValue, un)}
      </QuantityValueContainer>
    )
}